import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination-new',
  template: `
    <div class="pagination-new">
      <button class="pagination-new__btn" [disabled]="current === 1" (click)="go(current - 1)">
        <app-icon name="chevron-left" [size]="14" [strokeWidth]="2.2"></app-icon>
      </button>
      <ng-container *ngFor="let page of pages">
        <span *ngIf="page === -1" class="pagination-new__ellipsis">&hellip;</span>
        <button *ngIf="page !== -1"
          class="pagination-new__btn"
          [class.pagination-new__btn--active]="page === current"
          (click)="go(page)">
          {{ page }}
        </button>
      </ng-container>
      <button class="pagination-new__btn" [disabled]="current === total" (click)="go(current + 1)">
        <app-icon name="chevron-right" [size]="14" [strokeWidth]="2.2"></app-icon>
      </button>
    </div>
  `
})
export class PaginationNewComponent {
  @Input() current = 1;
  @Input() total = 1;
  @Output() pageChange = new EventEmitter<number>();

  get pages(): number[] {
    const t = this.total;
    if (t <= 5) {
      return Array.from({ length: t }, (_, i) => i + 1);
    }
    const c = this.current;
    const result: number[] = [1, 2, 3];
    if (c > 3 && c < t) {
      result.push(-1, c);
    }
    if (t > 3 && !result.includes(t)) {
      result.push(-1, t);
    }
    return result;
  }

  go(page: number): void {
    if (page >= 1 && page <= this.total && page !== this.current) {
      this.pageChange.emit(page);
    }
  }
}
